export function countSecurityTracingsByRule(securityTracings) {
  var counts = new Map();
  securityTracings.forEach(function (_ref) {
    var _counts$get;

    var securityOptionId = _ref.securityOptionId;
    counts.set(securityOptionId, ((_counts$get = counts.get(securityOptionId)) !== null && _counts$get !== void 0 ? _counts$get : 0) + 1);
  });
  return counts;
}